import {Tag} from "@blueprintjs/core";
import {JobStatus} from "../../utils/stops/JobStatusResolver";

type StatusBadgeProps = {
  status: JobStatus;
};

type StatusDisplay = {
  color: string | undefined;
  backgroundColor: string | undefined;
};

const StatusMap = new Map<string, StatusDisplay>([
  ["Assigned", {color: "#F6F7F9", backgroundColor: "#32A467"}],
  ["New", {color: "#F6F7F9", backgroundColor: "#2d72d2"}]
]);

const JobStatusBadge = ({status}: StatusBadgeProps) => {
  const resolvedStatus = StatusMap.get(status.name);
  let style = {};
  if (resolvedStatus) {
    style = {...resolvedStatus};
  }
  return (
    <Tag minimal style={style}>
      {status.name}
    </Tag>
  );
};

export default JobStatusBadge;
